// src/components/Nav/WealthNavbar.tsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ShoppingCart } from "lucide-react";
import logo from "../../assets/logo/logo2.png";

type Props = {
  compact?: boolean;
};

const WealthNavbar: React.FC<Props> = ({ compact = false }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="bg-transparent">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left: Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="Logo" className="h-6 w-auto" />
            </Link>
          </div>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="#what" className="text-sm text-mutedGray hover:text-brandNavy">
              What you'll learn
            </Link>
            <Link to="#bonuses" className="text-sm text-mutedGray hover:text-brandNavy">
              Bonuses
            </Link>
            <Link to="#results" className="text-sm text-mutedGray hover:text-brandNavy">
              Results
            </Link>

            <button
              onClick={() => navigate("checkout")}
              className="ml-4 inline-flex items-center gap-2 bg-brandRed text-brandWhite px-4 py-2 rounded-lg text-sm font-semibold hover:bg-brandRedHover transition"
            >
              <ShoppingCart className="w-4 h-4" />
              Buy Now
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center">
            <button
              aria-label={open ? "Close menu" : "Open menu"}
              onClick={() => setOpen((v) => !v)}
              className="p-2 rounded-md text-mutedGray hover:text-brandNavy hover:bg-bgGray transition"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu (collapsible) */}
        {open && (
          <div className="md:hidden mt-2 pb-4 border-t border-lightBorder">
            <div className="flex flex-col gap-2 px-1 py-3">
              <Link
                to="#what"
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-base font-medium text-brandNavy hover:bg-bgGray"
              >
                What you'll learn
              </Link>
              <Link
                to="#bonuses"
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-base font-medium text-brandNavy hover:bg-bgGray"
              >
                Bonuses
              </Link>
              <Link
                to="#results"
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-base font-medium text-brandNavy hover:bg-bgGray"
              >
                Results
              </Link>

              <button
                onClick={() => {
                  setOpen(false);
                  navigate("checkout");
                }}
                className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-brandRed text-brandWhite px-4 py-2 rounded-lg text-sm font-semibold hover:bg-brandRedHover transition"
              >
                <ShoppingCart className="w-4 h-4" />
                Buy Now
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default WealthNavbar;
